import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, TabContent, TabPane, Nav, NavItem, NavLink, Progress } from 'reactstrap';
import FormItem from './formularioItem.js';
import NewForm from '../newForms/createForm'
import Firebase from 'firebase';
import DraftItem from './draftItem'
import TemplateItem from './templateItem'


var ReactToastr = require("react-toastr");
var { ToastContainer } = ReactToastr;
var ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);

export default class listForm extends React.Component {
    constructor() {
        super();
        this.state = {
            limit: true,
            filtro: "all",
            trial: false,
            showModalNew: false
        }
    }

    componentDidMount() {
        var clientRef = Firebase.database().ref('clients/' + localStorage.client_id);
        clientRef.on("value", snap => {
            if (snap.val().trial) {
                this.setState({ trial: true });
            }
        });
        var formRef = Firebase.database().ref('forms');
        formRef
            .orderByChild('client_id')
            .equalTo(localStorage.client_id)
            .on('value', resp => this.setState({ forms: resp.val() }));
        var draftRef = Firebase.database().ref('draft');
        draftRef
            .orderByChild('client_id')
            .equalTo(localStorage.client_id)
            .on('value', resp => {
                this.setState({ draft: resp.val() })
            });
        var templateRef = Firebase.database().ref('templates');
        templateRef
            .on('value', resp => this.setState({ templates: resp.val() }));
        if (this.state.draft === null && this.state.forms == null) {
            console.log("entro")
            this.setState({ limit: false })
        }
    }


    componentWillUpdate(nextProps, nextState) {
        if (nextState.draft !== this.state.draft) {
            if (nextState.trial && nextState.draft) {
                if (Object.keys(nextState.draft).length < 1) {
                    this.setState({ limit: false })
                }
            }
            if (nextState.draft === null && nextState.forms == null) {
                console.log("entro")
                this.setState({ limit: false })
            }
        }
        else if (nextState.forms !== this.state.forms) {
            if (nextState.trial && nextState.forms) {
                if (Object.keys(nextState.forms).length < 1) {
                    this.setState({ limit: false })
                }
            }
            if (nextState.draft === null && nextState.forms == null) {
                console.log("entro")
                this.setState({ limit: false })
            }
        }
    }

    renderForms() {
        switch (this.state.filtro) {
            case "all":
                return (
                    <div className="form-group row" style={{ padding: "10px" }}>
                        <div className="col-md-12 col-lg-12 col-md-12 row">
                            {
                                this.state.draft !== undefined && this.state.draft !== null ?
                                    Object.keys(this.state.draft).map((d, index) =>
                                        <div className="col-sm-6 col-md-3 col-lg-3" key={index} style={{ width: "45%", marginRight: "10px" }}>
                                            <DraftItem formulario={Object.values(this.state.draft)[index]} id={d} />
                                        </div>
                                    )
                                    :
                                    ""
                            }
                        </div>
                        <div className="col-md-12 col-lg-12 col-md-12 row">
                            {
                                this.state.forms !== undefined && this.state.forms !== null ?
                                    Object.keys(this.state.forms).map((f, index) =>
                                        <div className="col-sm-6 col-md-3 col-lg-3" key={index} style={{ width: "45%", marginRight: "10px" }}>
                                            <FormItem formulario={Object.values(this.state.forms)[index]} id={f} />
                                        </div>
                                    )
                                    :
                                    ""
                            }
                        </div>
                    </div>
                )
            case "forms":
                if (this.state.forms !== undefined && this.state.forms !== null) {
                    return (
                        <div className="form-group row" style={{ padding: "10px" }}>
                            {
                                Object.keys(this.state.forms).map((f, index) =>
                                    <div className="col-sm-6 col-md-3 col-lg-3" key={index} style={{ width: "45%", marginRight: "10px" }}>
                                        <FormItem formulario={Object.values(this.state.forms)[index]} id={f} />
                                    </div>
                                )
                            }
                        </div>
                    )
                } else {
                    return (
                        ""
                    )
                }
            case "draft":
                if (this.state.draft !== undefined && this.state.draft !== null) {
                    return (
                        <div className="form-group row" style={{ padding: "10px" }}>
                            {
                                Object.keys(this.state.draft).map((d, index) =>
                                    <div className="col-sm-6 col-md-3 col-lg-3" key={index} style={{ width: "45%", marginRight: "10px" }}>
                                        <DraftItem formulario={Object.values(this.state.draft)[index]} id={d} />
                                    </div>
                                )
                            }
                        </div>
                    )
                } else {
                    return (
                        ""
                    )
                }
            case "plantillas":
                if (this.state.templates !== undefined && this.state.templates !== null) {
                    return (
                        <div className="form-group row" style={{ padding: "10px" }}>
                            {
                                Object.keys(this.state.templates).map((d, index) =>
                                    <div className="col-sm-6 col-md-3 col-lg-3" key={index} style={{ width: "45%", marginRight: "10px" }}>
                                        <TemplateItem formulario={Object.values(this.state.templates)[index]} id={d} setTab={()=>{this.setState({filtro : "forms"})}} />
                                    </div>
                                )
                            }
                        </div>
                    )
                } else {
                    return (
                        ""
                    )
                }
        }
    }

    setTab(tab){
        this.setState({filtro : tab})
    }

    render() {
        return (
            <div className="animated fadeIn">
                <div className="row">
                    <ToastContainer
                        style={{ top: "60" }}
                        ref="container"
                        toastMessageFactory={ToastMessageFactory}
                        className="toast-top-right"
                    />
                    <div className="col-md-2 col-sm-12" style={{ borderRadius: "20px", background: "#DDDDDD" }}>
                        <section className="section section--menu">
                            <span className="link-copy"></span>
                            <nav className="menu menu--ferdinand">
                                <li className={this.state.filtro === "all" ? "menu__item menu__item--current" : "menu__item"}>
                                    <a onClick={() => { this.setState({ filtro: "all" }) }} style={{ cursor: "pointer", textAlign: "left" }} className="menu__link">Todos</a>
                                </li>
                                <li className={this.state.filtro === "forms" ? "menu__item menu__item--current" : "menu__item"}>
                                    <a onClick={() => { this.setState({ filtro: "forms" }) }} style={{ cursor: "pointer", textAlign: "left" }} className="menu__link">Publicados</a>
                                </li>
                                <li className={this.state.filtro === "draft" ? "menu__item menu__item--current" : "menu__item"}>
                                    <a onClick={() => { this.setState({ filtro: "draft" }) }} style={{ cursor: "pointer", textAlign: "left" }} className="menu__link">Borradores</a>
                                </li>
                                <li className={this.state.filtro === "plantillas" ? "menu__item menu__item--current" : "menu__item"}>
                                    <a onClick={() => { this.setState({ filtro: "plantillas" }) }} style={{ cursor: "pointer", textAlign: "left" }} className="menu__link">Plantillas</a>
                                </li>
                                <li className={this.state.filtro === "archivados" ? "menu__item menu__item--current" : "menu__item"}>
                                    <a onClick={() => { this.setState({ filtro: "archivados" }) }} style={{ cursor: "pointer", textAlign: "left" }} className="menu__link">Archivados</a>
                                </li>
                                <li className={this.state.showModalNew === true ? "menu__item menu__item--current" : "menu__item"}>
                                    {
                                        (this.state.limit && this.state.trial)
                                            ?
                                            <p className="text-muted" onClick={() => {
                                                this.refs.container.warning(
                                                    "Se ha superado el limite de formularios posibles",
                                                    "Versión de pruebas", {
                                                        timeOut: 3000,
                                                        extendedTimeOut: 10000
                                                    });
                                            }}>
                                                <i className="fa fa-plus"></i> Añadir formulario
                                            </p>
                                            :
                                            <a onClick={() => this.setState({ showModalNew: true })} style={{ cursor: "pointer", textAlign: "left" }} className="menu__link"><i className="fa fa-plus"></i> Añadir formulario</a>

                                    }
                                </li>
                            </nav>
                        </section>
                    </div>
                    <div className="col-md-10 col-sm-12">
                        <div className="animated fadeIn">
                            {this.renderForms()}
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.showModalNew} toggle={() => { this.setState({ showModalNew: false }) }} className="modal-dialog modal-lg">
                    <ModalHeader toggle={() => { this.setState({ showModalNew: false }) }}>
                    </ModalHeader>
                    <ModalBody>
                        <NewForm />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/forms/listForm.js